import FloatingUiController from '../../javascript/controllers/floating_ui'

export default class TooltipController extends FloatingUiController {
  connect() {
    super.connect()
    this.fixupDOM()
  }

  fixupDOM() {
    super.fixupDOM()
    this.element.classList.add('tooltip-container')
    this.popupTarget.classList.add('tooltip')
  }

  // The .tooltip stylesheet hides the popup with both display and visibility, so an inline display is not
  // enough to reveal it — the data-show attribute is what the stylesheet keys on.
  displayPopup() {
    this.popupTarget.setAttribute('data-show', '')
  }

  hidePopup() {
    this.popupTarget.removeAttribute('data-show')
  }
}
